import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import "./components/_common/i18n";
import { getLanguage } from "./components/_common/i18n";

import ProjectThemeProvider from "./components/_themes/ProjectThemeProvider";
import Routes from "./Routes";
import AccessibilityMeta from "./components/_common/AccessibilityMeta";

const App = () => {
    const language = getLanguage();
    const LOADING = language === "en" ? "Loading" : "Ładowanie";

    const noscriptEl = document.getElementsByTagName("noscript")?.[0];
    if (noscriptEl) {
        noscriptEl.remove();
    }
    return (
        <ProjectThemeProvider>
            <Suspense
                fallback={
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "fixed",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            fontSize: "1.5rem",
                            fontFamily: "'Open Sans', sans-serif",
                            gap: 32,
                        }}
                    >
                        <img
                            src={`/${language}/logos/logo-rsi-long.svg`}
                            alt={"GUS RSI - logo"}
                            style={{ maxHeight: 48 }}
                        />

                        {LOADING}
                    </div>
                }
            >
                <AccessibilityMeta />
                <Routes />
            </Suspense>
        </ProjectThemeProvider>
    );
};

export default App;
